import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="conditional-toggler"
export default class extends Controller {
  static targets = [ "togglee" ]
  static values = {
    toggleOn: String,
    toggleOnType: { type: String, default: 'String' }
  }

  HIDE_CLASS = 'd-none'

  toggle(event) {
    if (!this.isToggled() && this.canToggleOn(event.target)) {
      this.toggleOn()
    } else {
      this.toggleOff()
    }
  }

  isToggled() {
    return !this.toggleeTarget.classList.contains(this.HIDE_CLASS)
  }

  canToggleOn(element) {
    if (this.toggleOnTypeValue === 'String') {
      return element.value === this.toggleOnValue
    } else if (this.toggleOnTypeValue === 'Checkbox') {
      return element.labels?.item(0)?.textContent === this.toggleOnValue && element.checked
    }
    return false
  }

  toggleOn() {
    this.toggleeTarget.classList.remove(this.HIDE_CLASS)
  }

  toggleOff() {
    this.toggleeTarget.classList.add(this.HIDE_CLASS)
  }
}
